import * as React from "react";

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.273}
      d="M.5 1.864H.364v6.059c0 6.106 4.95 11.056 11.056 11.056 6.106 0 11.056-4.95 11.056-11.056V1.864h-1.383v6.059c0 5.342-4.331 9.672-9.673 9.672s-9.673-4.33-9.673-9.672V1.864H.5Z"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.273}
      d="M10.68 18.337h-.137v14.387a6.8 6.8 0 0 0 13.599 0v-2.96a8.192 8.192 0 0 1 8.192-8.193h.136v-1.383h-.136a9.575 9.575 0 0 0-9.575 9.576v2.96a5.416 5.416 0 1 1-10.832 0V18.338H10.68Z"
    />
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.273}
      d="M40.158 20.694a3.75 3.75 0 1 1-7.501 0 3.75 3.75 0 0 1 7.5 0Zm-3.75 5.134a5.134 5.134 0 1 0 0-10.267 5.134 5.134 0 0 0 0 10.267Z"
    />
  </svg>
);
export default SvgComponent;
